import React from 'react'
import { StarIcon } from '@phosphor-icons/react'
import Spacer from '@components/common/Spacer';

const UserReview = ({reviews}) => {
    
    const { review } = reviews;
    
  return (
    <React.Fragment>
      <div className="w-full flex flex-col gap-y-6 mb-6">
        <div className="w-full flex justify-between">
          <span className="text-[1rem] text-primary font-medium">
            {review?.title}
          </span>
          <div className="flex">
            <StarIcon size={20} weight="fill" />
            <span className="ml-2">{review?.rating}</span>
          </div>
        </div>

        <div className="space-y-4">
          <p>{review?.body}</p>
            {
                review?.imagesFileName && (
                    <img 
                        src={`https://cdn.stamped.io/tr:h-180:/uploads/photos/${review.imagesFileName}`} 
                        height="130" 
                        alt={review?.productTitle || "Review Image"} 
                    />
            )
}

          <div className="flex flex-nowrap gap-x-1 text-xs text-[#888888]">
            <span>{review?.author}</span>
            <span>•</span>
            <span>{review?.productTitle}</span>
          </div>
        </div>

        <Spacer height='1px' />
      </div>
    </React.Fragment>
  );
}

export default UserReview